import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  GenericTableHeaderComponent,
  GenericTableHeaderOptions,
  RefreshData,
  SortItem,
  TableComponent,
  FilterItem,
} from '@huge-monorepo/shared/components';
import {
  ICustomerGenericService,
  IHIPGenericService,
  SideTagConfig,
  TeltonikaDashboardData,
  TeltonikaDevice,
} from '@huge-monorepo/shared/interfaces';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { Device, TableAction, TableHeader, Tag } from '@huge-monorepo/shared/interfaces';
import { Router } from '@angular/router';
import { DialogService, SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { CommonModule } from '@angular/common';
import { TeltonikaSelectTagModalComponent } from '../modals/teltonika-select-tag-modal/teltonika-select-tag-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TeltonikaUpdateNameModalComponent } from '../modals/teltonika-update-name-modal/teltonika-update-name-modal.component';
import { TeltonikaCreateReportModalComponent } from '../modals/teltonika-create-report/TeltonikaCreateReportModal.component';
import { TeltonikaExecuteTaskModalComponent } from '../modals/teltonika-execute-task-modal/TeltonikaExecuteTaskModal.component';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { TeltonikaTaskPollingModalComponent, TeltonikaTaskState } from '../modals/teltonika-task-polling-modal/teltonika-task-polling-modal.component';
import { YesNoModalComponent } from '@huge-monorepo/shared/tools';
import { map, Observable } from 'rxjs';
import { TeltonikaFilters } from 'libs/shared/src/interfaces/TeltonikaFilters';
import {
  TeltonikaUpdateDeviceModalComponent
} from '../modals/teltonika-update-device-modal/teltonika-update-device-modal.component';
import { TeltonikaUpdateDevicePollingModalComponent} from '../modals/teltonika-update-device-polling-modal/teltonika-update-device-polling-modal.component';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'teltonika-track-home',
  templateUrl: './teltonika-home.component.html',
  styleUrls: ['./teltonika-home.component.scss'],
  standalone: true,
  imports: [MatCardModule, MatProgressBarModule, GenericTableHeaderComponent, ToolsModule, MaterialModule, CommonModule],
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0',
          minHeight: '0',
          overflow: 'hidden',
          padding: '0',
          margin: '0',
          opacity: '0',
        }),
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: '1',
        }),
      ),
      transition('expanded <=> collapsed', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TeltonikaHomeComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  isHIP = this.sharedTeltonikaService.getIsHIP();

  @ViewChild('table') table: TableComponent;
  @ViewChild('tableHeader') tableHeader: GenericTableHeaderComponent;
  tilesLoading: boolean = true;
  totalTileData: { heading: string, total: number, date: string };
  infoTileData: InfoTileData[] = [];
  tilesUpdatedAt: string | null = null;

  showActionContainer: boolean = false;

  sortColumn: string = 'ID';
  sortDesc: boolean = false;

  showTable: boolean = true;

  statusFilter: string | null = null;

  index = 0;

  searchTerm: string | null = '';
  savedSearchData: SavedSearchData = {
    searchTerm: null,
    statusFilter: null,
    teltonikaFilters: { Firmware: null, Model: null, TagID: null, SignalStrength: null }
  };

  selectedDevices: object[] = [];

  firmwareFilters: string[] = [];
  modelFilters: string[] = [];
  tagFilters: Tag[] = [];
  signalStrengthFilters: string[] = [];
  isInfoTilesCollapsed = false;
  appliedFilters: { Firmware: string | null, Model: string | null, TagID: number | null, SignalStrength: string | null } = { Firmware: null, Model: null, TagID: null, SignalStrength: null };

  lastRefresh: Date = new Date();

  deviceReachableOptions = [
    { Text: 'Online', Name: 'Online', Value: 'Online' },
    ...(this.isHIP ? [{ Text: 'Action Required', Name: 'ActionRequired', Value: 'Action Required' }] : []),
    { Text: 'Offline', Name: 'Offline', Value: 'Offline' },
    { Text: 'All', Name: 'All', Value: null }];
  reachableStatus: any = 'Online';
  page: string = "Reachable";

  allSelected: boolean = false;

  addSelected(e: object[]) {
    this.selectedDevices = e;
  }

  toggleInfoTiles(): void {
    this.isInfoTilesCollapsed = !this.isInfoTilesCollapsed;
  }

  rebootDevices() {
    const selectedIds = this.selectedDevices.map((device) => {
      return device['id'];
    });

    const dialogRef = this.dialog.open(YesNoModalComponent, {
      data: { Heading: 'Reboot Devices', Message: 'Are you sure you want to reboot the selected devices?' }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null && result === true) {
        this.selectedDevices = [];

        this.teltonikaService.rebootDevices(selectedIds, this.allSelected ? { Search: this.searchTerm == "" ? null : this.searchTerm, DeviceStatus: this.reachableStatus, ...this.appliedFilters } : null).subscribe({});
        this.allSelected = false;
        this.table.allToggledModel = false;
        this.genericSingleton.service.createToast('Devices Rebooting', 'Reboot command sent', 'info');

      }
    });
  }

  runTeltonikaTask() {
    const dialogRef = this.dialog.open(TeltonikaExecuteTaskModalComponent, {
      width: '500px',
      maxHeight: '600px',
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result.TaskID == null) {
          return;
        } else {
          const deviceIDs: number[] = this.selectedDevices.map((device) => device["id"]);
          this.teltonikaService.executeTeltonikaTask(result.TaskID, deviceIDs, this.allSelected ? { Search: this.searchTerm == "" ? null : this.searchTerm, DeviceStatus: this.reachableStatus, ...this.appliedFilters } : null).subscribe({
            next: (resp) => {
              const sessionGuid = resp.SessionGUID

              this.toastr.success('Task is being executed');

              const dialogRef = this.dialog.open(TeltonikaTaskPollingModalComponent, {
                width: '60vw',
                data: { sessionGuid: sessionGuid, taskId: result.TaskID, devices: this.selectedDevices.map((device) => { return { Name: device["TeltonikaCustomName"], ID: device["id"], Serial: device["name"], Status: TeltonikaTaskState.loading } }) }
              });

              this.dialogService.RegisterDialog(dialogRef);
              dialogRef.afterClosed().subscribe((result) => {
                this.dialogService.DeRegisterDialog(dialogRef);
              });
            },
            error: (err) => {
              this.toastr.error('Error starting execution');
              this.allSelected = false;
              this.showTable = true;
            }
          });
          // this.selectedDevices = []; // Clear selected devices after operation
        }
      }
    });

  };

  selectTagMultipleDevices() {
    const dialogRef = this.dialog.open(TeltonikaSelectTagModalComponent, {
      width: '500px',
      maxHeight: '600px',
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result !== null) {
        if (result !== false) {
          this.showTable = false;
          const deviceIDs: number[] = this.selectedDevices.map((device) => device["id"]);
          const selectAllObj = this.allSelected ? { Search: this.searchTerm == "" ? null : this.searchTerm, DeviceStatus: this.reachableStatus, ...this.appliedFilters } : null
          this.teltonikaService.upsertExtraInfo({ DeviceIDs: deviceIDs, NewTagID: result, ...selectAllObj }).subscribe({
            next: (resp) => {

              this.toastr.success('Device Tags Updated');
              this.allSelected = false;
              this.showTable = true;
            },
            error: (err) => {

              this.toastr.error('Error updating device tags');
              this.allSelected = false;
              this.showTable = true;
            }
          });
          this.selectedDevices = []; // Clear selected devices after operation
        }
      }
    });
  }

  isNumber(value: any): value is number {
    return typeof value === 'number';
  }

  setFilter(values: any) {

    this.showTable = false;
    this.selectedDevices = []; // Clear selected devices after operation

    if (values) {

      if (values.Search) {
        this.searchTerm = values.Search;
      } else {
        this.searchTerm = null;
      }

      if (values.Sort) {
        this.sortColumn = values.Sort;
        this.sortDesc = values.Desc;
      } else {
        this.sortColumn = "ID";
        this.sortDesc = values.Desc;

      }
      if (values.Filters) {
        let firmware: string | null = null;
        let model: string | null = null;
        let tag: Tag | null = null;
        let signalStrength: string | null = null;

        values.Filters.forEach((filter) => {
          if (filter.Name === "Firmware") {
            firmware = filter.value;
          } else if (filter.Name === "Model") {
            model = filter.value;
          } else if (filter.Name === "Tag") {
            tag = filter.value ?? null;
          } else if (filter.Name === "Signal Strength") {
            signalStrength = filter.value ?? null;
          }
        });
        this.appliedFilters = { Firmware: firmware, Model: model, TagID: tag != null ? (tag as Tag).ID : null, SignalStrength: signalStrength };
      }
      this.updateSavedSearchData();

    } else {
      this.searchTerm = '';
      this.sortColumn = "ID";
      this.sortDesc = false;
    }
    setTimeout(() => {
      this.allSelected = false;
      this.showTable = true;
    }, 0);
  }

  sideTagConfig: SideTagConfig = {
    PropertyID: 'TeltonikaStatus',
    ColourMapping: { 'Offline': 'red', 'Online': 'green', 'Action Required': 'orange', 'Unknown': 'grey', 'default': 'grey' },
    tooltipTextFn: (element) => {  // Assign the function directly
      let tooltipText = '';
      if (this.sideTagConfig.PropertyID == 'TeltonikaStatus') {
        tooltipText += 'Status: ' + `${element.TeltonikaStatus ?? 'Unknown'}`;
        if (element.TeltonikaStandardCheckInTimestamp) {
          tooltipText += '\n' + `Last Standard Check-In: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(element.TeltonikaStandardCheckInTimestamp))}`;
        }

        if (element.TeltonikaReachableTimestamp) {
          tooltipText += '\n' + `Last Reachable: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(element.TeltonikaReachableTimestamp))}`;
        }
      }
      return tooltipText;
    }
  };

  headers: TableHeader[] = [
    {
      ID: 'TeltonikaCustomName',
      Index: this.index++,
      Sort: 'TeltonikaCustomName',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
      Link: (device) => {
        this.router.navigate([`/Teltonika/Dashboard/device/${device.id}`]);
        sessionStorage.setItem('navigationType', 'in-app');
      },
      Width: 130,
    },
    ...(this.isHIP ?
      [
        {
          ID: 'TeltonikaSortTag',
          Index: this.index++,
          Sort: 'TeltonikaTag',
          Sortable: false,
          Text: 'Tag',
          Type: String,
          Align: 'left',
          Wrapper: (device) => {
            if (device.TeltonikaTag) {
              return device.TeltonikaTag.Name;
            }
            return '-';
          },
          Link: (device) => {
            this.router.navigate([`/Teltonika/Tags/${device.TeltonikaTag.ID}`]);
            sessionStorage.setItem('navigationType', 'in-app');
          },
          Width: 100,
        },
      ] : []),
    {
      ID: 'CustomerReference',
      Index: this.index++,
      Sort: 'customerReference',
      Sortable: false,
      Text: 'Company Name',
      Type: String,
      Align: 'left',
      Width: 300,
    },
    {
      ID: 'DeviceNum',
      Index: this.index++,
      Sort: 'name',
      Sortable: false,
      Text: 'Serial',
      Type: String,
      Align: 'left',
      Link: (device) => {
        this.router.navigate([`/Teltonika/Dashboard/device/${device.id}`]);
        sessionStorage.setItem('navigationType', 'in-app');
      },
      Width: 100,
    },
    {
      ID: 'MACAddress',
      Index: this.index++,
      Sort: 'MACAddress',
      Sortable: false,
      Text: 'MAC',
      Type: String,
      Align: 'left',
      Width: 120,
    },
    {
      ID: 'DeviceType',
      Index: this.index++,
      Sort: 'deviceType',
      Sortable: false,
      Text: 'Model',
      Type: String,
      Align: 'left',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          // Replace the "Teltonika" part of the model name with "RUT"
          return elem.replace('Teltonika', 'RUT');
        }
        return '-';
      },
      Width: 50,
    },
  ];

  headerFilterUpdate = (selection: { Name: string, Value: any }[]): Observable<FilterItem[]> => {
    const firmwareSearch = selection.find((f) => f.Name === "Firmware");
    const firmware = firmwareSearch != null && firmwareSearch.Value != null ? firmwareSearch.Value : null;
    const modelSearch = selection.find((f) => f.Name === "Model");
    const model = modelSearch != null && modelSearch.Value != null ? modelSearch.Value : null;
    const tagSearch = selection.find((f) => f.Name === "Tag");
    const tagId = tagSearch != null && tagSearch.Value != null ? tagSearch.Value.ID : null;
    const SignalStrengthSearch = selection.find((f) => f.Name === "Signal Strength");
    const SignalStrength = SignalStrengthSearch != null && SignalStrengthSearch.Value != null ? SignalStrengthSearch.Value : null;

    return this.teltonikaService.getFilters(firmware, model, tagId, this.reachableStatus != "" ? this.reachableStatus : null, SignalStrength).pipe(map((data: TeltonikaFilters) => {
      let newFilterItems: FilterItem[] = [];
      if (data != null) {
        if (data.Firmwares != null && data.Firmwares.length > 0) {
          newFilterItems.push({ Name: "Firmware", Values: data.Firmwares, DefaultValue: firmware });
        }
        if (data.Models != null && data.Models.length > 0) {
          newFilterItems.push({ Name: "Model", Values: data.Models, DefaultValue: model });
        }
        if (data.Tags != null && data.Tags.length > 0 && this.isHIP) {
          newFilterItems.push({ Name: "Tag", Values: data.Tags, DefaultValue: tagId, Wrapper: (tag: Tag) => { return tag.Name }, compareFn: (o1, o2) => { return o1 != null && o2 != null && o1.ID === o2.ID } });
        }
        if (data.SignalStrength != null && data.SignalStrength.length > 0) {
          newFilterItems.push({
            Name: "Signal Strength",
            Values: data.SignalStrength,
            DefaultValue: SignalStrength,
          });
        }
      }
      return newFilterItems;
    }));

  }

  headerConfig: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchFilters: true,
    EnableExport: false,
    SearchPlaceholder: "Search Devices",
    SortItems: this.headers.map(h => {
      if (h.ID === "customerReference") {
        return ({ Display: h.Text, Name: 'Customer.Reference' } as SortItem)
      } else if (h.ID === "name") {
        return ({ Display: h.Text, Name: 'DeviceNum' } as SortItem)
      }
      return ({ Display: (h.ID !== "TeltonikaStatus" ? h.Text : "Status"), Name: h.ID } as SortItem)
    }),
    FilterItems: [
      { Name: "Firmware", Values: this.firmwareFilters },
      { Name: "Model", Values: this.modelFilters },
      ...(this.isHIP ? [{ Name: "Tag", Values: this.tagFilters, Wrapper: (tag: Tag) => { return tag.Name }, compareFn: (o1, o2) => { return o1.ID === o2.ID } }] : []),
      { Name: "Signal Strength", Values: this.signalStrengthFilters },
    ],
    DynamicFilterUpdateFn: this.headerFilterUpdate
  };

  actions: TableAction[] = [
    {
      Icon: 'visibility',
      Text: 'View',
      Caller: (p: Device) => {
        this.router.navigate([`/Teltonika/Dashboard/device/${p.id}`]);
        sessionStorage.setItem('navigationType', 'in-app');
      },
      Validator: (d: Device) => {
        if (d.RouterType == 'Teltonika_Custom' && d.LastIP == null && d.LastInform == null) {
          return false;
        }
        return true;
      }
    },
    ...(this.isHIP && this.isHipTeltonikaAdmin() ? [
      {
        Icon: 'sell',
        Text: 'Select Tag',
        Caller: (p: Device) => {
          this.selectTag(p);
        },
      },
      {
        Icon: 'edit_square',
        Text: 'Update Name',
        Caller: (p: Device) => {
          this.updateName(p);
        },
      },
    ] : []),
    ...(this.isHIP || (!this.isHIP && this.isPortalRemoteAccess()) ? [
      {
        Icon: 'web',
        Text: 'Open HTTP Connection',
        Caller: (p: TeltonikaDevice) => {
          let ip: string = "";
          if (p.LastIP) {
            ip = p.LastIP;
          } else if (p.TeltonikaVPNIP) {
            ip = p.TeltonikaVPNIP;
          } else {
            this.genericSingleton.service.createToast('Error', 'No IP address found', 'error');
            return;
          }

          this.teltonikaService.startTeltonikaTunneling(p.id, 80, ip).subscribe({
            next: (data) => {
              window.open(`http://${data}`, "_blank");
            },
            error: (error) => {
              this.genericSingleton.service.createToast('Error', 'Failed to open HTTP tunnel', 'error');
            },
          });

        },
      },
      {
        Icon: 'key',
        Text: 'Open SSH Terminal',
        Caller: (p: TeltonikaDevice) => {
          let ip: string = "";
          if (p.LastIP) {
            ip = p.LastIP;
          } else if (p.TeltonikaVPNIP) {
            ip = p.TeltonikaVPNIP;
          } else {
            this.genericSingleton.service.createToast('Error', 'No IP address found', 'error');
            return;
          }

          const url = this.router.serializeUrl(
            this.router.createUrlTree([`/Teltonika/terminal/${p.id}/${encodeURIComponent(ip)}`])
          );
          window.open(url, '_blank');
        },
      },
    ] : []),
  ];

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private router: Router,
    private tools: SharedToolsService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private genericSingleton: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
  ) {

  }

  ngOnInit(): void {
    if (sessionStorage.getItem('navigationType') === 'in-app') {
      this.setupSavedSearchData();
    }
    sessionStorage.removeItem('navigationType');
    this.populateDashboardData();
  }

  populateDashboardData(opn: boolean = false): void {
    this.tilesLoading = true;
    this.teltonikaService.getDashboardData(opn).subscribe((data: TeltonikaDashboardData) => {
      this.tilesUpdatedAt = data.LastNonCachedResponse.toLocaleString('sv-SE');
      this.infoTileData = [
        {
          heading: 'STATUS',
          total: data.OverallCounts.Total - data.OverallCounts.NotActivated,
          data: [
            {
              title: 'Online',
              value: data.OverallCounts.Online,
              color: "green"
            },
            ...(this.isHIP ? [{
              title: 'Action Required',
              value: data.OverallCounts.ActionRequired,
              color: "orange"
            }] : []),
            {
              title: 'Offline',
              value: data.OverallCounts.Offline,
              color: "red"
            },
            {
              title: 'Unknown',
              value: data.OverallCounts.NotActivated,
            }
          ],
        },
        {
          heading: 'DEVICE MODEL',
          total: data?.OverallCounts?.Total ?? 0,
          data: data?.ModelCounts?.map(elem => {
            return { title: elem.Model.replace('Teltonika', 'RUT'), value: elem.Count };
          })
        },
        {
          heading: 'DEVICE FIRMWARE',
          total: data?.FirmwareCounts?.length ?? 0,
          data: data?.FirmwareCounts
            ?.slice() // clone to avoid mutating the original array
            .sort((a, b) => b.Count - a.Count) // descending order by Count
            .map(elem => ({
              title: elem.Firmware,
              value: elem.Count
            }))
        },
        {
          heading: 'MOBILE SIGNAL',
          total: data.OverallCounts.Total - data.OverallCounts.NotActivated,
          data: [
            {
              title: 'Excellent',
              value: data.SignalCounts.Excellent,
              color: 'forestgreen'
            },
            {
              title: 'Good',
              value: data.SignalCounts.Good,
              color: '#ccffcc'
            },
            {
              title: 'Fair',
              value: data.SignalCounts.Fair,
              color: '#f9e93e'
            },
            {
              title: 'Poor',
              value: data.SignalCounts.Poor,
              color: 'orange'
            },
            {
              title: 'No Signal',
              value: data.SignalCounts["No Signal"],
              color: 'firebrick'
            },
            {
              title: 'Unknown',
              value: data.SignalCounts.Unknown,
            },
          ]
        },
      ]
      this.totalTileData = {
        heading: 'TOTAL DEVICES',
        total: data.OverallCounts.Total,
        date: this.tools.FormatDateFromDate(new Date())
      }
      this.tilesLoading = false;
    });
  }

  selectTag(p) {
    const dialogRef = this.dialog.open(TeltonikaSelectTagModalComponent, {
      width: '700px'
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result != false) {
          this.showTable = false;

          this.teltonikaService.upsertExtraInfo({ DeviceIDs: [p.id], Name: p.TeltonikaCustomName, NewTagID: result }).subscribe({
            next: (resp) => {

              this.toastr.success('Device Tag Updated');
              this.allSelected = false;
              this.showTable = true;
            },
            error: (err) => {

              this.toastr.error('Error updating device tag');
              this.allSelected = false;
              this.showTable = true;
            }
          });
          this.selectedDevices = []; // Clear selected devices after operation
        }
      }
    });
  }

  generateReport() {
    if (this.selectedDevices.length === 0 && !this.allSelected) {
      this.toastr.error('No devices selected');
      return;
    }

    const dialogRef = this.dialog.open(TeltonikaCreateReportModalComponent, {
      width: '800px',
      data: { devices: JSON.parse(JSON.stringify(this.selectedDevices)), allSelected: this.allSelected }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);

      if (result != null) {
        this.teltonikaService.exportReportingData(result.DeviceIDs, result.Start, result.End, this.allSelected ? { Search: this.searchTerm == "" ? null : this.searchTerm, DeviceStatus: this.reachableStatus, ...this.appliedFilters } : null).subscribe({
          next: (resp) => {
            this.toastr.success('Report Generated');
          },
          error: (err) => {
            this.toastr.error('Error generating report');
          }
        });
      }
    });
  }

  updateName(p) {
    const dialogRef = this.dialog.open(TeltonikaUpdateNameModalComponent, {
      width: '700px',
      data: { currentName: p.TeltonikaCustomName }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result !== null) {
        if (result.Name != null) {
          this.showTable = false;
          let devId = null;
          if (p.TeltonikaTag) {
            devId = p.TeltonikaTag.ID ?? null;
          }
          this.teltonikaService.upsertExtraInfo({ DeviceIDs: [p.id], Name: result.Name, NewTagID: devId }).subscribe({
            next: (resp) => {

              this.toastr.success('Device Name Updated');
              this.allSelected = false;
              this.showTable = true;
            },
            error: (err) => {

              this.toastr.error('Error updating device Name');
              this.allSelected = false;
              this.showTable = true;
            }
          });
          this.selectedDevices = []; // Clear selected devices after operation
        }
      }
    });
  }

  statusChanged(val: any) {
    this.showTable = false;
    this.reachableStatus = val;
    this.tableHeader.dynamicallyUpdateFilters();
    this.updateSavedSearchData();
    setTimeout(() => {
      this.allSelected = false;
      this.showTable = true;
    }, 0);
    this.selectedDevices = []; // Clear selected devices after operation
  }


  changeTab(e) {
    this.page = e.tab.title;
  }

  selectedContainsDisabledDevice() {
    if (this.allSelected && this.reachableStatus == "Online") {
      return false;
    }
    if (this.selectedDevices.length > 0) {
      return this.selectedDevices.some(device => {
        return device["TeltonikaStatus"] !== "Online";
      });
    }
    return true;
  }

  allDevicesSelected(event: boolean) {
    this.allSelected = event;
  }


  getHTTPData() {
    let deviceTypes: { name: string }[] | null = null;
    if (this.appliedFilters.Model != null) {
      // We need to replace "RUT" with "Teltonika" in the model name because we do it the other way around in the Wrapper
      deviceTypes = [{ name: this.appliedFilters.Model.replace('RUT', 'Teltonika') }];
    }
    return { TeltonikaReachable: this.reachableStatus, DeviceTypes: deviceTypes, TeltonikaFirmware: this.appliedFilters.Firmware, TeltonikaTagID: this.appliedFilters.TagID, TeltonikaSignalStrength: this.appliedFilters.SignalStrength };
  }

  async openUpdateTeltonikaDevice(): Promise<void> {
    const dialogRef = this.dialog.open(TeltonikaUpdateDeviceModalComponent, {
      width: '500px',
      height: '70vh',
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result: 'success' | null) => {
      this.dialogService.DeRegisterDialog(dialogRef);

      if (result === 'success') {
        this.toastr.success('Updated Devices');
      }
    });
  }

  isHipTeltonikaAdmin(): boolean {
    return this.teltonikaService.isHipTeltonikaAdmin();
  }

  isPortalRemoteAccess(): boolean {
    return this.teltonikaService.isTeltonikaRemoteAccess();
  }

  refreshDashboard(): void {
    if ((new Date().getTime() - this.lastRefresh.getTime()) >= 10000) {
      this.lastRefresh = new Date();
      this.populateDashboardData(true);
    } else {
      this.genericSingleton.service.createToast('Error', 'Please wait before refreshing the dashboard tiles', 'error');
    }
  }

  onTileClick(category: string, value: string): void {
    // Clear all filters in the UI and internal state
    ['Model', 'Firmware', 'Signal Strength', 'TagID'].forEach(key => {
      switch (key) {
        case 'Model':
          this.appliedFilters.Model = null;
          break;
        case 'Firmware':
          this.appliedFilters.Firmware = null;
          break;
        case 'Signal Strength':
          this.appliedFilters.SignalStrength = null;
          break;
        case 'TagID':
          this.appliedFilters.TagID = null;
          break;
      }

      this.tableHeader?.filterForms[key]?.setValue(null);
    });


    let newFilter: { Name: string, value: any } | null = null;

    switch (category) {
      case 'STATUS':
        this.statusChanged(value === 'All' ? null : value);
        return;
      case 'DEVICE MODEL':
        const modelValue = value.replace(/^RUT/, 'Teltonika');
        this.appliedFilters.Model = modelValue;
        this.tableHeader?.filterForms['Model']?.setValue(modelValue);
        newFilter = { Name: "Model", value: modelValue };
        break;
      case 'DEVICE FIRMWARE':
        this.appliedFilters.Firmware = value;
        this.tableHeader?.filterForms['Firmware']?.setValue(value);
        newFilter = { Name: "Firmware", value };
        break;
      case 'MOBILE SIGNAL':
        this.appliedFilters.SignalStrength = value;
        this.tableHeader?.filterForms['Signal Strength']?.setValue(value);
        newFilter = { Name: "Signal Strength", value };
        break;
      default:
        return;
    }

    if (newFilter) {
      this.setFilter({ Filters: [newFilter] });
    }
  }

  updateSavedSearchData(): void {
    this.savedSearchData.searchTerm = this.searchTerm;
    this.savedSearchData.statusFilter = this.reachableStatus;
    this.savedSearchData.teltonikaFilters = this.appliedFilters;
    sessionStorage.setItem('teltonikaSavedSearchData', this.savedSearchData ? JSON.stringify(this.savedSearchData) : '');
  }

  setupSavedSearchData(): void {
    const savedSearchData = sessionStorage.getItem('teltonikaSavedSearchData');
    if (savedSearchData) {
      this.savedSearchData = JSON.parse(savedSearchData);
      this.searchTerm = this.savedSearchData.searchTerm;
      this.reachableStatus = this.savedSearchData.statusFilter;
      this.appliedFilters = this.savedSearchData.teltonikaFilters;
    } else {
      this.savedSearchData = {
        searchTerm: null,
        statusFilter: null,
        teltonikaFilters: { Firmware: null, Model: null, TagID: null, SignalStrength: null }
      };
    }
  }
}

interface InfoTileData {
  heading: string;
  data?: InfoTileInnerData[];
  total?: number;
}

interface InfoTileInnerData {
  title: string;
  color?: string;
  value: number;
}

interface SavedSearchData {
  searchTerm: string | null;
  statusFilter: string | null;
  teltonikaFilters: { Firmware: string | null, Model: string | null, TagID: number | null, SignalStrength: string | null };
}
